import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function ScandalTracker() {
  const scandalArticles = articles.filter(
    (a) => a.category === 'wanghong-fanche' || a.category === 'zhibo-fanche'
  ).slice(0, 4);

  return (
    <section className="py-10 md:py-14">
      <div className="mx-auto px-4 md:px-6 max-w-7xl flex items-center justify-between mb-6">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-alert-line text-accent-500 text-xl"></i>
            </div>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900">
              网红翻车现场实时追踪
            </h2>
          </div>
          <p className="text-foreground-500 text-sm mt-1">第一时间直击网红翻车名场面</p>
        </div>
        <Link to="/category/wanghong-fanche" className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer">
          更多翻车 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mx-auto px-4 md:px-6 max-w-7xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {scandalArticles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}